import { MutationTree } from "vuex";
import { HomeResources, HomeState } from "../../interface";
import { updateHomeResources, resetHomeState } from "./mutation-types";

export const mutations: MutationTree<HomeState> = {
  [resetHomeState]: (state: HomeState) => {
    console.log("resetHomeState");
    state.homeResources = {};
    console.log(state);
  },
  [updateHomeResources]: (state: HomeState, payload: HomeResources) => {
    console.log("updateHomeResources:", payload);
    state.homeResources = payload;
  }
};
